<mat-card
	mat-dialog-content
	class="sdp-confirmation-dialog-container"
>
	<h3 class="sdp-confirmation-dialog-header">{{ title | translate }}</h3>
	<div
		class="sdp-confirmation-dialog-message"
		[innerHTML]="message"
	></div>
	<form [formGroup]="form">
		<div class="sdp-form-control">
			<mat-slide-toggle
				formControlName="disable"
				matTooltip="{{ disableTooltip | translate }}"
				(change)="disableChanged()"
			>Disable this user.</mat-slide-toggle>
		</div>
		<div class="sdp-form-control">
			<mat-slide-toggle
				formControlName="all"
				matTooltip="{{ allTooltip | translate }}"
			>Disconnect all sessions for this user.</mat-slide-toggle>
		</div>
	</form>
	<div class="sdp-form-buttons-container sdp-confirmation-dialog-splitter">
		<button
			class="sdp-button-small-text"
			type="button"
			color="primary"
			mat-button
			(click)="cancel()"
			[disabled]="showProgressBar"
		>{{ buttonCancel | translate }}</button>
		<button
			type="button"
			color="primary"
			mat-raised-button
			(click)="action()"
			[disabled]="showProgressBar"
		>{{ buttonAction | translate }}</button>
	</div>
	<mat-progress-bar
		mode="indeterminate"
		*ngIf="showProgressBar"
		class="sdp-progress-bar"
	></mat-progress-bar>
</mat-card>